import React from 'react';
import PositionMenu from './PositionMenu';
import ActionButton from '../../../components/common/ActionButtonAndMenu/ActionButton';

const PositionBulkActions = ({ selectedPositions, handleAction }) => {
    return (
        <PositionMenu
            label="Bulk Actions"
            Component={ActionButton}
            row={selectedPositions[0]}
            handleAction={handleAction}
            type="bulk"
        />
    );
};

export default PositionBulkActions;
